import { formatNumber } from '../../../utils/number/formatNumber.js';

const NumberFormat = ({
  value: valueProp,
  ...props
}) => {
  const value = formatNumber(valueProp, props);
  return value;
};
NumberFormat.displayName = "NumberFormat";

export { NumberFormat };
//# sourceMappingURL=index.js.map
